import { createRequest } from '../../hub/request';
import { getStorefrontLookup } from '../../shared/lookups';
import { RequestData, RequestDTO, StorefrontDTO } from '../../../../contract/dtos';
import { MutationSchema, QuerySchema } from '../types';

// Export the mutation for creating a new request
export const requestMutations = {
  create: (): MutationSchema<RequestData, RequestDTO> => ({
    mutationKey: ['request', 'create'],
    mutationFn: async (requestData: RequestData) => {
      return await createRequest(requestData);
    }
  })
};

// Export the query for getting storefront lookup data
export const requestQueries = {
  storefrontLookup: (): QuerySchema<StorefrontDTO[], any> => ({
    queryKey: ['storefront-lookup'],
    queryFn: async () => {
      return await getStorefrontLookup();
    }
  })
};

